import {Loan} from "../../openapi-ts";
import PurposeEnum = Loan.PurposeEnum;

export const apptrackAddSecondDeptorUrl = (token: string) : string => {
  const layout = window['wf_layout'] != 'check24' ? '&layout=' + window['wf_layout'] : '';
  return '/start/kredit-apptrack?pageDesktop=PERSON1&pageMobile=MOBILE_2_PERSON1&applicants.twoApplicants=true' + layout + '#/KREDIT/' +
    token
    '/entry';
}

export const closingtrackUrl = (token: string, loanAmount: number, contractStateFlow: string) : string => {
  const layout = window['wf_layout'] != 'check24' ? '&layout=' + window['wf_layout'] : '';

  return contractStateFlow === 'PRELIMINARY'
      ? '/start/kredit-closingtrack/?t=' +
      encodeURIComponent(token) +
      '&loan.amount=' +
      loanAmount + layout +
      '#/acceptterms'
      : '/start/kredit-closingtrack/?t=' +
      encodeURIComponent(token) +
      '&loan.amount=' +
      loanAmount + layout;
}
